import actionTypes from 'redux/actions/actionTypes';
import initialState from 'redux/initialState';

import { HoldingClass } from 'types';

import { actionTypes as customTypes } from 'modules/_shared/redux/resetActions';

type HoldingClassAction = {
  type: string;
  holdingClasses?: HoldingClass[];
  holdingClass?: HoldingClass;
};

const resetStateSociety = (): HoldingClass[] => initialState.holdingClasses;

const createHoldingClass = (
  holdingClasses: HoldingClass[],
  action: HoldingClassAction
): HoldingClass[] =>
  action.holdingClass && holdingClasses?.length < 10
    ? [...holdingClasses, action.holdingClass]
    : holdingClasses;

const getHoldingClasses = (action: HoldingClassAction): HoldingClass[] =>
  action.holdingClasses || [];

const updateHoldingClass = (
  holdingClasses: HoldingClass[],
  action: HoldingClassAction
): HoldingClass[] =>
  holdingClasses?.map((holdingClass: HoldingClass) =>
    holdingClass._id === action.holdingClass?._id
      ? action.holdingClass
      : holdingClass
  );

const reducer = (
  holdingClasses: HoldingClass[] = initialState.holdingClasses,
  action: HoldingClassAction
) => {
  switch (action.type) {
    case customTypes.RESET_STATE_SOCIETY:
      return resetStateSociety();

    case actionTypes.CREATE_HOLDING_CLASS:
      return createHoldingClass(holdingClasses, action);

    case actionTypes.GET_HOLDING_CLASSES:
      return getHoldingClasses(action);

    case actionTypes.UPDATE_HOLDING_CLASS:
      return updateHoldingClass(holdingClasses, action);

    default:
      return holdingClasses;
  }
};

export default reducer;
